/* eslint-disable camelcase */
  <template >
  <div >
    <br>
  <div>
  <div class="formPosition">

<v-form
    ref="form"
    v-model="valid"
    lazy-validation
>
  <v-row>
    <template>
      <v-card style="margin:auto;" width="1200">
        <v-overlay :value="overlay">
              <v-progress-circular indeterminate size="70"></v-progress-circular>
            </v-overlay>
        <v-container   style="background-color:#006699; color:white;border-bottom:1px solid white;">
      <div>
         <span>Painel de Gestão de Licenças</span>
         <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs"
            v-on="on" style="float:right;color:white;">info
          </v-icon>
        </template>
        <span>Clique aqui para saber como criar um novo Produto</span>
      </v-tooltip>
      </div>
  </v-container>
        <v-tabs
          v-model="tab"
          background-color="#006699"
          dark
        >
          <v-tab
            v-for="item in items"
            :key="item.tab"
          >
            {{ item.tab }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <!--======================== Tab Geral ========================================-->
          <v-tab-item>
              <v-card flat>
                    <v-alert
                      v-model="alert"
                      dismissible
                      :type="alertType"
                      border="left"
                      :icon="iconAlert"
                      transition="scale-transition"
                      :style="colorAlert"
                      elevation="2"
                      colored-border
                    >
                    {{msgAlert}}
                  </v-alert>
                    <v-card-text>
                      <v-container>
                        <v-row>
                            <v-col md="12">
                                  <v-data-table
                                  :headers="headers"
                                  :items="instituicoes"
                                  :search="search"
                                  >
                                  <template v-slot:item.licencaActivada="{ item }">
                                   <v-icon color="red" v-if="item.licencaActivada === 0">close</v-icon>
                              </template>
                                  </v-data-table>
                            </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
          </v-tab-item>
          <!--====================== END Tab Geral ========================================================================= -->

           <!--======================== Tab 2 ========================================-->
          <v-tab-item>
              <v-card flat>
                    <v-alert
                      v-model="alert"
                      dismissible
                      :type="alertType"
                      border="left"
                      :icon="iconAlert"
                      transition="scale-transition"
                      :style="colorAlert"
                      elevation="2"
                      colored-border
                    >
                    {{msgAlert}}
                  </v-alert>
                    <v-card-text>
                        <span style="font-weight:bold;">Geração de uma nova Licença</span>
                      <v-container>
   <v-form
    ref="form2"
    v-model="valid2"
    lazy-validation
>
                        <v-row>
                          <v-col md="8">
                               <v-combobox
                                  v-model="instituicaoSelected"
                                  :items="instituicoes"
                                  :rules="ruleRequired"
                                  item-text="descricao"
                                  item-value="descricao"
                                  filled
                                  background-color="#ffff99"
                                  label="Selecione a instituição"
                                  small-chips
                                  return-object
                                >
                                </v-combobox>
                          </v-col>
                          <v-col md="4">
                                 <v-combobox
                                  v-model="tipoLicencaSelected"
                                  :items="tipoLicenca"
                                  :rules="ruleRequired"
                                  item-text="descricao"
                                  item-value="descricao"
                                  label="Selecione o Plano"
                                  small-chips
                                  return-object
                                  @change="SelecionaTipoLicenca()"
                                >
                                </v-combobox>
                          </v-col>
                          <v-col md="4">
                             <small>Data de Expiração:</small><span>{{expiracao}}</span>
                          </v-col>
                        </v-row>
   </v-form>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn style="color:white;" :disabled="!valid2" @click="GerarLicenca()" color="green darken-1">Gerar Licença</v-btn>
                    </v-card-actions>
                  </v-card>
                  <v-card v-if="save_status">
             <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
                {{ $store.state.textMessage }}
              </div>
            <v-card-actions>
             <v-col md="8">
                           <p style="font-weight:bold;">Licença: <span style="color:green;font-size:32px;">{{descricaoLicenca}}</span> <br> Guarde esta licença e forneça ao respectivo cliente</p>
              </v-col>
               <v-btn color="blue darken-1" text @click="Fechar()">Ja guardei a licença, fechar</v-btn>
           </v-card-actions>
          </v-card>

          </v-tab-item>
          <!--====================== END Tab Desconto =================================== -->
        </v-tabs-items>
      </v-card>
    </template>

  </v-row>
  </v-form>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import utilitarios from '../../plugins/utilitarios'
let generator = require('generate-password')
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    isLoading_: false,
    search: '',
    descricaoLicenca: '',
    menuFab: null,
    menuExp: null,
    valid2: true,
    overlay: false,
    produtosDesconto: [],
    bancos: [],
    instituicoes: [],
    instituicaoSelected: null,
    moedas: [],
    menuDataExpiracao: null,
    opcaodescontoglobal: null,
    opcaoSelecionada: null,
    tipoLicencaSelected: null,
    descontoFlag: false,
    flagDescontoGlobal: false,
    dataExpiracao: '',
    save_status: false,
    dateExpiracao: null,
    dataFabrico: '',
    produtoSelecionado: null,
    bancoSelected: null,
    valid: true,
    expiracao: '',
    produtos: [],
    contas: [],
    alert: false,
    iconAlert: '',
    alertType: '',
    colorAlert: '',
    msgAlert: '',
    dias: '',
    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    editedIndex: -1,
    editedItem: {
      nome: '',
      endereco: '',
      telefone1: '',
      telefone2: '',
      email: '',
      observacao: ''
    },
    editedItemDefault: {
      nome: '',
      endereco: '',
      telefone1: '',
      telefone2: '',
      email: '',
      observacao: ''
    },
    tab: null,
    items: [
      { tab: 'Licenças atribuidas', content: 'Tab 1 Content' },
      { tab: 'Gerar Nova Licença', content: 'Tab 2 Content' }
    ],
    headers: [
      { text: 'Instituição', value: 'descricao' },
      { text: 'Licença activa', value: 'licencaActivada' },
      { text: 'Data de Atribuição', value: 'dataAtribuicao' },
      { text: 'Data de Expiração', value: 'dataExpiracao' },
      { text: 'Licença Gerada por', value: 'atribuidaPor' }
    ],
    tipoLicenca: [
      { id: 1, descricao: 'Mensal' },
      { id: 2, descricao: 'Trimestral' },
      { id: 3, descricao: 'Anual' }
    ],

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleNumberNObrigatorio: [
      value => {
        const pattern = /^[0-9]+([,.][0-9]+)?$/g
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ]
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },

    returnImagem () {
      return this.imageData
    }

  },

  watch: {
    menuFab (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menuExp (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    },
    model (val) {
      if (val.length > 1) {
        this.$nextTick(() => this.model.pop())
      }
    },
    search (val) {
      // Items have already been loaded
      if (val.length >= 4) {
      // Items have already been requested
        if (!this.produtos.filter(t => t.descricao.includes(val)).length) {
          this.produtos = []
          return this.initializeProdutos(val)
        }
      }

      if (val.length >= 4) { return this.initializeProdutos(val) }
    }

  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.InitializeInstituicoes()
  },

  methods: {
    Continuar () {
      if (this.$refs.form.validate()) {
        this.tab = 1
      }
    },
    async  InitializeInstituicoes () {
      try {
        //   let  payload =""
        this.overlay = true
        this.instituicoes = await axios
          .get('/listarInstituicao')
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async ListarMoedas () {
      try {
        //   let  payload =""
        this.moedas = await axios
          .get('/moedaFindAll')
          .then(res => res.data)
        this.moedas.push({ pkMoeda: -1, descricao: 'Nova Moeda', icone: true })
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    SelecionaTipoLicenca () {
      this.expiracao = utilitarios.RetornaDataExpiracao(this.tipoLicencaSelected.id)
      this.dias = utilitarios.RetornaDias(this.tipoLicencaSelected.id)
    },
    async SaveConta () {
      if (this.$refs.form2.validate()) {
        this.overlay = true
        let params =
          {
            fkBanco: this.bancoSelected.pkBanco,
            contas: this.contas
          }
        try {
        //   let  payload =""
          let msg = await axios
            .post('/ContaFatInsertOrUpdate', params)
            .then(res => res.data)

          if (msg.AffectedRwos >= 1) {
            this.showAlertSucess('Conta associada ao Banco com sucesso')
            this.Limpar2()
            this.overlay = false
          }
        } catch (error) {
          this.overlay = false
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },
    SelecionaMoeda (indice) {
      let moeda = this.contas[indice].moeda
      if (moeda.pkMoeda === -1) {
        this.contas[indice].moeda = null
        this.contas[indice].moeda.descricao = ''
      }
    },
    AddTabela () {
      if (this.$refs.form2.validate()) {
        let params =
        {
          conta: '',
          iban: '',
          descricao: '',
          moeda: ''
        }
        this.contas.push(params)
      }
    },

    GerarLicenca () {
      this.overlay = true
      setTimeout(() => {
        this.overlay = false
        this.save_status = true
        this.descricaoLicenca = this.licencagenerator()
      }, 1000)
    },

    async  savebanco () {
      if (this.$refs.form.validate()) {
        this.overlay = true
        let params =
          {
            pkBanco: 0,
            nome: this.editedItem.nome,
            endereco: this.editedItem.endereco,
            telefone1: this.editedItem.telefone1,
            telefone2: this.editedItem.telefone2,
            email: this.editedItem.email,
            obs: this.editedItem.observacao

          }
        try {
        //   let  payload =""
          let msg = await axios
            .post('/BancoFatInsertOrUpdate', params)
            .then(res => res.data)
          console.log(msg)
          if (msg.affectedRows >= 1) {
            this.showAlertSucess('Banco inserido com sucesso')
            this.Limpar()
            this.overlay = false
          }
        } catch (error) {
          this.overlay = false
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

    showAlertSucess (msg) {
      this.alert = true
      this.tab = 0
      this.colorAlert = 'color:green;'
      this.iconAlert = 'done'
      this.alertType = 'success'
      this.msgAlert = msg
      setTimeout(() => {
        this.alert = false
      }, 4000)
    },

    licencagenerator () {
      return generator.generate({ length: 12, numbers: true })
    },

    remover (indice) {
      this.contas.splice(indice, 1)
    },

    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
      this.Limpar()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    saveDateExpiracao (date) {
      this.$refs.menuDataExpiracao.save(date)
      this.dataExpiracao = date
    },

    Limpar () {
      this.editedItem = this.editedItemDefault
      this.tipoLicencaSelected = ''
      this.instituicaoSelected = ''
      this.expiracao = ''
      this.save_status = false
    },
    Limpar2 () {
      this.editedItem = this.editedItemDefault
      
    },
    async  Fechar () {
      // this.save_status = false
      if (this.$refs.form.validate()) {
        this.overlay = true
        let params =
          {
            instituicao: this.instituicaoSelected.idInstituicao,
            chave: this.descricaoLicenca,
            dataExpiracao: this.expiracao,
            dias: this.dias
          }
        try {
        //   let  payload =""
          let msg = await axios
            .post('/licencaInstituicaoInsert', params)
            .then(res => res.data)
          if (msg.affectedRows >= 1) {
            this.showAlertSucess('Licença Gerada com sucesso')
            this.Limpar()
            this.overlay = false
          }
        } catch (error) {
          this.overlay = false
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    }
  }

}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}
.file-upload-form, .image-preview {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    padding: 20px;
}
img.preview {
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}

</style>
